module.exports = __webpack_public_path__ + "img/图片9.ce4a8b2f.png";